import type { RootState } from '../configure-store';
import { createSelector } from '@reduxjs/toolkit';
import { selectShippingRegionCountryCodeIso2 } from 'tradera/state/shipping-region/selectors';
import { isSwedenCountryCodeOrUndefined } from 'tradera/localization/countrycode';
import { selectPageType } from '../page/selectors';

export const selectDiscover = (state: RootState) => state.discover;

export const selectDisplayCountyFilter = (state: RootState) => {
    return (
        isSwedenCountryCodeOrUndefined(
            selectShippingRegionCountryCodeIso2(state)
        ) && selectPageType(state) !== 'ProfilePage_items'
    );
};

export const selectSaveSearchData = createSelector(
    (state) => state.discover,
    ({
        queryParams,
        currentCategoryId,
        headerText,
        totalItems,
        isSavedSearchEmailEnabled
    }) => ({
        searchName: queryParams?.q || headerText,
        categoryId: currentCategoryId,
        queryParams,
        totalItems,
        isSavedSearchEmailEnabled
    })
);

export const selectCategoryPath = (state: RootState) =>
    state.discover.categoryPath;

export const selectItemConditionFilter = (state: RootState) =>
    state.discover.filters?.itemCondition;

export const selectSellerTypeFilter = (state: RootState) =>
    state.discover.filters?.sellerType;

export const selectCountyFilter = (state: RootState) =>
    state.discover.filters?.county;

export const selectItemTypeFilter = (state: RootState) =>
    state.discover.filters?.itemType;

export const selectSortByFilter = (state: RootState) =>
    state.discover.filters?.sortBy;

export const selectAllowedBuyerRegionsFilter = (state: RootState) =>
    state.discover.filters?.allowedBuyerRegions;

export const selectItemStatusFilter = (state: RootState) =>
    state.discover.filters?.itemStatus;

export const selectWardrobeProfile = (state: RootState) =>
    state.discover.wardrobeProfile;
